<template>
    <div id="app" class="pb-5">
        <div class="container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'App',
    }
</script>

<style>
    #app {
        direction: rtl !important;
        max-width: 768px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*min-height: calc(100vh);*/
        box-sizing: content-box;
        background-color: #fff;
        margin: auto;
        font-family: 'Iran Yekan', serif;
    }
</style>
